import type { MeasureIntegrationDetailsDTO, MeasureSimulationCandidateDTO } from '@/src/api/types/procurement'
import type { AdjustmentWarning } from '../table/adjustmentTable.types'
import type { AdjustmentRow } from '../table/adjustmentTable.types'

export interface LoadPlanningMeasureModalItem {
  id?: string
  measureId?: string
  effectiveFrom?: string
  name?: string
  consumptionDelta?: number
  simulationChangeStatus?: MeasureIntegrationDetailsDTO['simulationChangeStatus']
  timeframeStart?: string
  timeframeEnd?: string
  measureConsumptionDelta?: number
  warnings?: AdjustmentWarning[]
  scope?: 'LOCATION' | 'COMPANY'
  locationId?: number
  simulationId?: string
  adjustmentType?: AdjustmentRow['adjustmentType']
}

export const mapAdjustmentRowToLoadPlanningMeasureModalItem = (row: AdjustmentRow): LoadPlanningMeasureModalItem => ({
  id: row.measureIntegrationDetails?.measureSimulationId,
  measureId: row.measureIntegrationDetails?.measureId,
  effectiveFrom: row.measureIntegrationDetails?.effectiveFrom,
  simulationChangeStatus: row.measureIntegrationDetails?.simulationChangeStatus,
  measureConsumptionDelta: row.measureIntegrationDetails?.consumptionDeltaKwh,
  name: row.name,
  consumptionDelta: row.consumptionDelta,
  timeframeStart: row.timeframeStart,
  timeframeEnd: row.timeframeEnd,
  warnings: row.warnings,
  scope: row.scope,
  locationId: row.locationId,
  simulationId: row.measureIntegrationDetails?.measureSimulationId,
  adjustmentType: row.adjustmentType,
})

export const mapMeasureCandidateToLoadPlanningMeasureModalItem = (row: MeasureSimulationCandidateDTO): LoadPlanningMeasureModalItem => ({
  id: row.id == null ? undefined : String(row.id),
  measureId: row.measureReference?.id == null ? undefined : String(row.measureReference.id),
  effectiveFrom: row.measureReference?.effectivenessDate,
  name: row.name,
  consumptionDelta: row.consumptionDelta,
  locationId: row.locationId,
})
